export function lang(key: string): string {
    const normalized = key
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // supprime les accents
        .replace(/[^a-z0-9]+/g, '_')                      // remplace les caractères spéciaux par _
        .replace(/^_+|_+$/g, '')                          // trim les _ en début/fin
    //console.log('normalized : ', normalized)
    return `i18n.app.management.${normalized}`
}
